import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=6b94484e"
import script from "./TablePagination.vue?vue&type=script&lang=js"
export * from "./TablePagination.vue?vue&type=script&lang=js"
import style0 from "./TablePagination.vue?vue&type=style&index=0&id=6b94484e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports